module.exports = __webpack_public_path__ + "static/media/logoJuegodelaBolsa2.1e3ff492.svg";